// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("turbolinks").start();
require("../src/scss/checkout.scss");
import jQuery from 'jquery'

const jQueryProp = {
    value: jQuery,
    configurable: false,
    writable: false
}

Object.defineProperties(window, { jQuery: jQueryProp, $: jQueryProp })

import "../src/js/lib/payment/jquery.payment";
require("../src/js/lib/remodal.js");
import Spinner from "../src/js/lib/spin";
// require("../src/js/lib/payment/jquery.payment");
require("../src/js/lib/payment/checkout");
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

jQuery.fn.spin = function(opts) {

    this.each(function() {
        var $this = $(this),
            data = $this.data();

        if (data.spinner) {
            data.spinner.stop();
            delete data.spinner;
        }

        data.spinner = new Spinner(jQuery.extend({color: $this.css('color')}, { lines: 8, length: 3, width: 3, radius: 5, left: '-16px' })).spin(this);
    });
    return this;
};